<template>
  <div style="height: 500px" class="overflow-auto">
    <table class="table ">
      <thead>
      <tr>
        <th scope="col">First name</th>
        <th scope="col">Last name</th>
        <th scope="col">Start date</th>
        <th scope="col">End date</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="holiday in holidaysInRange" :key="holiday.id">
        <td>{{ holiday.user.firstName }}</td>
        <td>{{ holiday.user.lastName }}</td>
        <td>{{ holiday.startDate }}</td>
        <td>{{ holiday.endDate }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';

const props = defineProps({
  holidaysInRange: {
    type: Array,
    required: true,
  },
});
</script>

<style scoped>

</style>